import type { SiteId } from "@/types/common/ids";
import type { Ref } from "vue";

export const CompanyQueryKeys = {
  all: ["company"] as const,
  findNetworkManagers: (siteId: Ref<SiteId | undefined>, cityCode: Ref<string | undefined>) =>
    [...CompanyQueryKeys.all, "network-managers", siteId, cityCode] as const,
};
